import { Component, ChangeDetectorRef, NgZone, ElementRef, ViewEncapsulation } from '@angular/core';
import { AppService } from '@suite/app.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateRange } from '@common/data-models/complex-types/date-range';
import { TimeoutQueue } from '@common/services/timeout-queue';

import { VisualStateService } from "@common/services/visual-state-service";
import { LanguageSettings } from "@common/services/language-settings";
import { GlobalTablesService } from "@common/services/global-tables-service";
import { EnpsControl } from '../enps-control/enps-control';
import { NomWebServicesJson } from '@suite/common/services/nom-web-services-json';
import moment, { Moment } from 'moment-timezone';
import { FormControl, FormGroup } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';


@Component({
    selector: 'date-time-range',
    templateUrl: './date-time-range.html',
    styleUrls: ['./date-time-range.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'st-date-time-range'
    },
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ]
})

export class DateTimeRange extends EnpsControl<DateRange> {

    public get value(): DateRange {
        return this._value;
    }
    public set value(v: DateRange) {
        this._value = v;
        this.range.setValue({
            from: (v.from) ? moment(v.from) : null,
            to: (v.to) ? moment(v.to) : null
        });
    }

    range = new FormGroup({
        from: new FormControl<Moment | null>(null),
        to: new FormControl<Moment | null>(null),
    });

    closed() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this._value.from = (this.range.value.from) ? this.range.value.from.toDate() : null;
            this._value.to = (this.range.value.to) ? this.range.value.to.toDate() : null;
            this.changed.emit(this.value);
        }
    }

    constructor(public appService: AppService,
        public changeDetectorRef: ChangeDetectorRef,
        ngZone: NgZone,
        timeoutQueue: TimeoutQueue,
        public visualStateService: VisualStateService,
        public languageSettings: LanguageSettings,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        elementRef: ElementRef,
        private dateAdapter: DateAdapter<Moment>,
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
        dateAdapter.setLocale(this.locale);
    }

    dateChange(value: MatDatepickerInputEvent<any>) {
        this.isValueChanged = true;
    }

    public clearDate() {
        this.range.setValue({
            from: null,
            to: null
        });
        this._value.from = null;
        this._value.to = null;
        this.changed.emit(this.value);
    }
}
